import React from "react";
import "./TotalPaymentBreakup.css";

import Pei_chart_holder from "./Pei_chart_holder/Pei_chart_holder";

const TotalPaymentBreakup = ({ EMITotal, interestTotal, loanValueTotal ,principalTotal}) => {
  const data = [
    {
      label: "Loan EMI",
      value: `₹ ${EMITotal}`,
    },
    {
      label: "Total Interest Payable",
      value: `₹ ${interestTotal}`,
    },
    {
      label: "Total Payment",
      sub_label: "(Principal + Interest)",
      value: `₹ ${loanValueTotal}`,
    },
  ];

  return (
    <section className="TotalPaymentBreakup">
      <div className="main_content_div">
        <div className="row">
          <div className="col-lg-5 ">
            <div className="outer_left_div">
              <div className="left_side_div">
                {data?.map((item) => {
                  return (
                    <div className="price_main_div">
                      <div className="title_div">
                        <p className="title">{item?.label}</p>
                        <p className="title">{item?.sub_label}</p>
                      </div>

                      <div className="value_div">
                        <p className="value_text">{item?.value}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="col-lg-7">
            <div className="right_side_div">
              <p className="div_title">Break up of Total Payment</p>
              <Pei_chart_holder
                loanValueTotal={loanValueTotal}
                interestTotal={interestTotal}
                EMITotal={EMITotal}
                principalTotal={principalTotal}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TotalPaymentBreakup;
